export default "__VITE_ASSET__DtZRyFNd__"